export default class AMOAccount {
  constructor(data) {
    for (let i in this.constructor.schema) {
      this[i] = this.constructor.schema[i].type(data[i]);
    }
  }

  static get schema() {
    return {
      id: { type: Number },
      name: { type: String },
      subdomain: { type: String },
      currency: { type: String },
      timezone: { type: String },
      timezone_offset: { type: String },
      language: { type: String },
      date_pattern: {
        type: v =>
          Object.keys(v).reduce((r, vv) => {
            r[v] = String(vv);
            return r;
          }, {})
      },
      current_user: { type: Number },
      custom_fields: { type: Object }, //array:4 [▶],
      note_types: { type: Object }, //array:18 [▶],
      task_types: { type: Object }, //array:2 [▶],
      groups: { type: Object }, //array:1 [▶],
      pipelines: { type: Object }, //Anemone\Core\Collection\Collection {#359 ▶},
      users: { type: Object } //Anemone\Core\Collection\Collection {#364 ▶},
    };
  }

  get schema() {
    return this.constructor.schema;
  }

  /**
   * @param {Function} filter
   * @param {string} including - Coma separated entities
   */
  customFields(filter, ...including) {
    if (!filter) {
      return this.custom_fields;
    }
    let t = this.custom_fields;
    !(including[0] instanceof Array) || (including = including[0]);
    return Object.keys(t).reduce((r, key) => {
      if (including.length && !including.includes(key)) {
        return r;
      }

      let v = Object.values(t[key]).filter(filter);
      !v.length || (r[key] = v);
      return r;
    }, {});
  }
}
